import { GridColDef } from '@mui/x-data-grid'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { BusinessLocationDto } from '@/generated/Messages/Basic_pb'

export const useBusinessLocationsDetailedColumns =
    (): GridColDef<BusinessLocationDto>[] => {
        const { t } = useTranslation()

        return useMemo(
            () => [
                {
                    field: 'name',
                    headerName: t('business.locationName'),
                    flex: 1,
                    filterable: false,
                    hideable: false,
                    resizable: false,
                },
                {
                    field: 'description',
                    headerName: t('common.description'),
                    flex: 1,
                    filterable: false,
                    hideable: false,
                    resizable: false,
                },
            ],
            [t]
        )
    }
